import React from "react";
import { Formik, FormikProps } from "formik";
import { Values } from "@src/Tools/Values";
import { Grid } from "@material-ui/core";
import { IValuesStore } from "@src/Stores/Values/types";
import _ from "lodash";
import * as Yup from "yup";
import { inject } from "mobx-react";
import { IManagementStore } from "@src/Stores/Management/types";
import { STButton, STFieldWrapper, STGrid } from "./styles";
import { IOptions } from "@src/Interfaces/Entity/Options";
import FormSwitch from "@src/Components/Common/FormFields/FormSwitch/FormSwitch";
import NumberField from "@src/Components/Ui/NumberField";
import { IAuthStore } from "@src/Stores/Auth/types";

const schema = Yup.object().shape({});

interface IProps {
  initialValues: IOptions;
  management?: IManagementStore;
  values?: IValuesStore;
  auth?: IAuthStore;
}

@inject("auth", "management", "values")
export default class GeneralForm extends React.Component<IProps> {
  handleSubmit = async (values: IOptions) => {
    await this.props.management.saveOptions(values);
  };

  render() {
    return (
      <Formik
        initialValues={this.props.initialValues}
        validationSchema={schema}
        onSubmit={this.handleSubmit}
        render={(formikProps: FormikProps<IOptions>) => (
          <form onSubmit={formikProps.handleSubmit}>
            <STFieldWrapper>
              <NumberField
                fieldName="tokenExpireTimeHours"
                label={Values.getLocalizationValue("tokenExpireTime")}
                formikProps={formikProps}
                disabled={!this.props.auth.user.location.primary}
              />
            </STFieldWrapper>

            <Grid container spacing={16} justify="flex-start" alignItems="center" zeroMinWidth>
              <STGrid item>
                <FormSwitch<IOptions>
                  trueAs={true}
                  falseAs={false}
                  fieldName="allowToSetupMultipleAssigns"
                  formikProps={formikProps}
                  disabled={!this.props.auth.user.location.primary}
                />
              </STGrid>
              <Grid item>{Values.getLocalizationValue("allowToSetupMultipleAssigns")}</Grid>
            </Grid>

            <Grid container spacing={16} justify="flex-start" alignItems="center" zeroMinWidth>
              <STGrid item>
                <FormSwitch<IOptions>
                  trueAs={true}
                  falseAs={false}
                  fieldName="isTwoFactorAuthenticationRequiredForElevatedPermissions"
                  formikProps={formikProps}
                  disabled={!this.props.auth.user.location.primary}
                />
              </STGrid>
              <Grid item>{Values.getLocalizationValue("requireTwoFactorAuthenticationRequiredForElevatedPermissions")}</Grid>
            </Grid>

            <Grid container justify="center">
              {this.props.auth.user.location.primary && (
                <STButton type="submit" variant="contained" color="primary">
                  {Values.getLocalizationValue("update")}
                </STButton>
              )}
            </Grid>
          </form>
        )}
      />
    );
  }
}
